import dayjs from 'dayjs';

const getYear = (date: Date | string): number => dayjs(date).year();

export { getYear };
